import { faFileImport } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a file import icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/file-import?f=classic&s=solid
 */
export const FileImportIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faFileImport} {...props} />;
};
